<template>
  <div class="process-list">
    <Toolbar class="nobackground">
      <template slot="left">
        <v-toolbar-title class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-book</v-icon>{{$t('process.documentations')}}
          </h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>

        <v-flex lg12>
   
          <v-container>
            <v-row>
              <v-col cols="12" sm="3" md="3" v-for="processtype in typeSelectItems" :key="processtype.id">
                  <v-card class=" " >
                    <v-img
                      height="200"
                      contain
                      aspect-ratio="1"
                      v-if="processtype.image"
                      @click="showType(processtype)"
                      v-on:click.right="showTypeExt(processtype)"
                      class="white--text align-end cursorpointer background_color_white"

                      :key="getItemImageKey(processtype)"
                      :src="getImageUrlByObject(processtype)"
                    >
                     </v-img>
                     <v-img v-else height="200" contain @click="showType(processtype)" v-on:click.right="showTypeExt(processtype)" class="secondary--text align-center align-end cursorpointer background_color_white text-center" >
                       <p class="textsize20 text-uppercase ma-5 familyGTAmerica" >{{ $t('global.nopicture') }}<br>{{ $t('global.available') }}</p>
                     </v-img>
                     <v-card-actions class="bordertop_white">
                       <span class="text-truncate">
                          
                          <span v-if="language == 'fr'">{{ processtype.namefr }}</span>
                          <span v-else>{{ processtype.name }}</span>
                        
                         <br>
                         <span  class="caption primary--text" ><!--{{$t('process.compatible')}} --></span>
                       </span>
                       <v-spacer></v-spacer>
                       <v-btn  class="" icon @click="showType(processtype)" v-on:click.right="showTypeExt(processtype)" >
                         <v-icon>mdi-launch</v-icon>
                       </v-btn>
                     </v-card-actions>
                   </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import i18n from '../../i18n.js';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import FileMixin from '../../mixins/FileMixin';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';

export default {
  name: 'ProcessListType',
  servicePrefix: 'Process',
  mixins: [ListMixin,FileMixin],
  components: {
    Loading,
    Toolbar
  },
  data() {
    return {
      filter: '250x250'
    };
  },
  mounted() {
    this.typeGetSelectItems({'orderCol'  : 'order[name]','order'  : 'asc'});
  },
  computed: {
    isLoading() {
      return (
        this.isLoading_type 
       );
    },
    ...mapFields('processtype', {
      typeSelectItems: 'selectItems',
      isLoading_type : 'isLoading'
    }),
    language() {
      return i18n.locale;
    }
  },
  methods: {
    ...mapActions({
      typeGetSelectItems: 'processtype/fetchSelectItems'
    }),
    
    showType(processtype) {
      if( processtype['@id']) {
        this.$router.push({ name: `ProcessListByType` , params: { id: processtype['@id'] }});
      }
    },
    showTypeExt(processtype) {
      let routeData = this.$router.resolve({
        name: `ProcessListByType`,
        params: { id: processtype['@id'] }
      });
      window.open(routeData.href, '_blank');
    },
  }
};
</script>
